import React, { useEffect, useState  } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import Header from '@/views/components/Header/Header';
import Footer from '@/views/components/Footer/Footer';
import TopSection from '@/views/components/SimpleTextAdivse/TopSection/TopSection';
import Pagination from '@/utils/pagination/Pagination';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import api from '@/services/api';
import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';
import Alert from '@/views/components/Alert/Alert';
import styles from '@/views/pages/SimpleTextAdvicesAdmin/SimpleTextAdvicesAdmin.module.scss';
import TableSubmited from '@/views/pages/SimpleTextAdvicesAdmin/parts/TableSubmited';
import TablePublish from '@/views/pages/SimpleTextAdvicesAdmin/parts/TablePublish';

const sortOptions = [ {
	id: 1,
	value: '-createdOn',
	label: 'ostatnio przesłane',
},
{
	id: 2,
	value: 'createdOn',
	label: 'najstarsze',
} ];

const SimpleTextAdvicesAdmin = () => {
	const [ questions, setQuestions ] = useState([]);
	const [ pages, setPages ] = useState(1);
	const [ tabs, setTabs ] = useState([]);
	const [ tabValue, setTabValue ] = useState(null);
	const [ tabCount, setTabCount ] = useState([]);
	const [ sortValue, setSortValue ] = useState(sortOptions[0]);
	const [ alert, setAlert ] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();
	const { search: locationSearch, pathname } = location;
	const isMobile = useWindowIsMobile(1200);
	const { dict, ppj } = useSelector(state => state.app);
	const itemsPerPager = 20;

	const getNameForLabel = (name) => {
		switch (name) {
			case "submitted":
				return `${dict.simpleTextAdvices.admin.tab.submitted} (${tabCount[name] ? tabCount[name] : "0"})`;
			case "in-progress":
				return `${dict.simpleTextAdvices.admin.tab.inProgress} (${tabCount[name] ? tabCount[name] : "0"})`;
			case "unpublished":
				return `${dict.simpleTextAdvices.admin.tab.unpublished} (${tabCount[name] ? tabCount[name] : "0"})`;
			case "published":
				return `${dict.simpleTextAdvices.admin.tab.published} (${tabCount[name] ? tabCount[name] : "0"})`;
			default:
				return ""; 
		}
	};

	const getQuestions = async () => {
		const params = new URLSearchParams(locationSearch);
		if(!tabValue) {
			getTabs();
		} else {
			const {data} = await api.get(`/questions/admin-questions?perpage=${itemsPerPager}&ord=${sortValue.value}&tabName=${tabValue}&${params}`);

			setPages(data.paginatedQuestions.pages);
			setQuestions(data.paginatedQuestions
				.questions);
			setTabCount(data.countedTabs);
		}
	};

	const getTabs = async () => {
		const {data} = await api.get(`/questions/admin-tabs`);
		const newTabs = Object.keys(data).map(key => ({
			id: parseInt(key),
			value: data[key], 
			label: getNameForLabel(data[key]),
		}));
		setTabs(newTabs);
		setTabValue(newTabs[0].value);
	};

	useEffect(() => {
		getQuestions();
	}, [ locationSearch, tabValue, sortValue ]);

	useEffect(() => {
		const params = new URLSearchParams(locationSearch);
		params.delete('page');
		navigate(`${pathname}?${params}`);
	}, [ tabValue ]);

	useEffect(() => {
		const tabsNumber = tabs.map(tab => ({...tab, label: getNameForLabel(tab.value)}));
		setTabs(tabsNumber);
	}, [ tabCount ]);
	
	const handleChange = (event, newValue) => {
		setTabValue(newValue);
	};

	const handleChangesort = (e) => {
		setSortValue(e);
	};

	const handleCloseAlert = () => {
		setAlert(null);
	};

	return (
		<>
			<Header narrow={ false } />
			<div className={ styles['admin__container'] }>
				<TopSection 
					description={  <> {ppj?.externalMode ? <p>
						{dict.simpleTextAdvices.admin.title1Uam}<br/>
						{dict.simpleTextAdvices.admin.title2Uam}<br/>
						{dict.simpleTextAdvices.admin.title3Uam}</p> : 
						<p>
							{dict.simpleTextAdvices.admin.title1}<br/>
							{dict.simpleTextAdvices.admin.title2}
						</p> }
					</> }
					subTitle={ dict.simpleTextAdvices.admin.subTitle }
				/>
				{alert && <Alert 
					variant={ alert.variant }
					alertContent={ alert.content }
					closeAction={ ()=> handleCloseAlert() }
				/>}
				<Tabs
					value={ tabValue }
					onChange={ handleChange }
					allowScrollButtonsMobile={ true }
					scrollButtons={ true }
					visibleScrollbar={ true }
					orientation={ isMobile ? 'vertical' : 'horizontal' }
				>
					{tabs && tabs.map(tab => 					
						<Tab
							key={ tab.id }
							value={ tab.value }
							label={ tab.label } />,
					)}
				</Tabs>
			
				<Pagination
					pagesNum={ pages }
					sortingOptions={ null }
					sortingValue={ null }
					sortingOnChange={ null }
					alignRight={ true }

				>
					<div className={ styles['admin__table__wrapper'] }>

						{(tabValue === 'submitted') || (tabValue === 'in-progress') ? <TableSubmited 
							questions={ questions }
							getQuestions={ getQuestions } 
							sortValue={ sortValue }
							sortOptions={ sortOptions }
							handleChangesort={ handleChangesort }
							pages={ pages }
							setAlert={ setAlert }

						/> : <TablePublish 
							questions={ questions }
							getQuestions={ getQuestions }
							publish={ tabValue === 'published' }
							sortValue={ sortValue }
							sortOptions={ sortOptions }
							handleChangesort={ handleChangesort }
							pages={ pages }
							setAlert={ setAlert }
						/>}
					</div>
				</Pagination>
			</div>
			<Footer />

		</>
	); 
};

export default SimpleTextAdvicesAdmin;